import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DashboardIcon from "@mui/icons-material/Dashboard";
import TableRowsIcon from "@mui/icons-material/TableRows";
import { Container, Grid } from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import {
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import TopBar from "../../../components/TopBar/TopBar";
import { AppColors } from "../../../util/AppColors";
import NewCalendar from "../../NewAppointment/NewCalendar/NewCalendar";
import Dashboard from "../Home/Home";
import "./Appointment.css";
import AppointmentApprove from "./AppointmentApprove";
import AppointmentsTab from "./AppointmentsTab";
import App from "./Dashboards.js/App";
import Facilities from "./Facilities";
import WhiteboardTab from "./WhiteboardTab";

const LAYOUT_APPOINTMENTS = "appointments";
const LAYOUT_GRID = "grid";
const LAYOUT_LIST = "list";

export const APPOINTMENTS_TAB_PATHS = {
  calendar: "calendar",
  whiteboard: "whiteboard",
  requests: "requests",
  approvals: "approvals",
  dashboard: "dashboard",
  facilities: "facilities",
};

export const APPOINTMENTS_PATH_TO_TAB = {
  calendar: "calendar",
  whiteboard: "whiteboard",
  requests: "requests",
  approvals: "approvals",
  dashboard: "dashboard",
  facilities: "facilities",
};

export const getAppointmentsBasePath = (pathname = "") =>
  pathname.startsWith("/dashboard") ? "/dashboard" : "/appointments";

export const AppointmentsRedirect = () => {
  const location = useLocation();
  const tabFromState = location.state?.selectedTab;
  const path =
    APPOINTMENTS_TAB_PATHS[tabFromState] ?? APPOINTMENTS_TAB_PATHS.calendar;
  const basePath = getAppointmentsBasePath(location.pathname);
  return <Navigate to={`${basePath}/${path}`} replace state={location.state} />;
};

const Appointments = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { tab } = useParams();
  const selectedTab = APPOINTMENTS_PATH_TO_TAB[tab];
  const basePath = getAppointmentsBasePath(location.pathname);
  const [layoutMode, setLayoutMode] = useState(LAYOUT_APPOINTMENTS);
  const showHomeToolbar =
    selectedTab === "calendar" && layoutMode === LAYOUT_APPOINTMENTS;
  const appointemntApproveList = useSelector(
    (state) => state?.clinic?.appointmentList,
  );

  const onChangeTab = (nextTab) => {
    if (!nextTab || nextTab === selectedTab) return;
    const path =
      APPOINTMENTS_TAB_PATHS[nextTab] ?? APPOINTMENTS_TAB_PATHS.calendar;
    navigate(`${basePath}/${path}`, { state: location.state });
  };

  if (!selectedTab) {
    return (
      <Navigate
        to={`${basePath}/${APPOINTMENTS_TAB_PATHS.calendar}`}
        replace
        state={location.state}
      />
    );
  }

  const layoutControls = (
    <div className="flex-row-ali-cen">
      <div
        className={`cursor cal-tab-icon day-type-box ${
          layoutMode === LAYOUT_APPOINTMENTS ? "blue-back-con" : ""
        }`}
        onClick={() => setLayoutMode(LAYOUT_APPOINTMENTS)}
      >
        <DashboardIcon
          sx={{
            height: 20,
            width: 20,
            color:
              layoutMode === LAYOUT_APPOINTMENTS
                ? AppColors.white
                : AppColors.gray,
          }}
        />
      </div>
      <div
        className={`cursor cal-tab-icon day-type-box ${
          layoutMode === LAYOUT_GRID ? "blue-back-con" : ""
        }`}
        onClick={() => setLayoutMode(LAYOUT_GRID)}
      >
        <CalendarMonthIcon
          sx={{
            height: 20,
            width: 20,
            color:
              layoutMode === LAYOUT_GRID ? AppColors.white : AppColors.gray,
          }}
        />
      </div>
      <div
        className={`cursor cal-tab-icon day-type-box ${
          layoutMode === LAYOUT_LIST ? "blue-back-con" : ""
        }`}
        onClick={() => setLayoutMode(LAYOUT_LIST)}
      >
        <TableRowsIcon
          sx={{
            height: 20,
            width: 20,
            color:
              layoutMode === LAYOUT_LIST ? AppColors.white : AppColors.gray,
          }}
        />
      </div>
    </div>
  );

  const headerRow = (
    <div className="flex-row-between w100Per">
      <div className="flex-row-ali-cen">
        <div className="ph10pv3" onClick={() => onChangeTab("calendar")}>
          <div
            className={`flex-center cursor ${
              selectedTab === "calendar"
                ? "pet-det-sel-tab"
                : "pet-det-un-sel-tab"
            }`}
          >
            Appointments
          </div>
        </div>

        {/* <div className="ph10pv3" onClick={() => onChangeTab("requests")}>
          <div
            className={`flex-center cursor ${
              selectedTab === "requests"
                ? "pet-det-sel-tab"
                : "pet-det-un-sel-tab"
            }`}
          >
            Requests
            {appointemntApproveList?.length > 0 && (
              <div className="red-dot request-btn-dot-pos" />
            )}
          </div>
        </div> */}

        <div className="ph10pv3" onClick={() => onChangeTab("approvals")}>
          <div
            className={`flex-center cursor ${
              selectedTab === "approvals"
                ? "pet-det-sel-tab"
                : "pet-det-un-sel-tab"
            }`}
          >
            Requests
            {/* Approvals */}
          </div>
        </div>

        <div className="ph10pv3" onClick={() => onChangeTab("facilities")}>
          <div
            className={`flex-center cursor ${
              selectedTab === "facilities"
                ? "pet-det-sel-tab"
                : "pet-det-un-sel-tab"
            }`}
          >
            Facilities
          </div>
        </div>
      </div>
      {selectedTab === "calendar" && !showHomeToolbar ? layoutControls : null}
    </div>
  );

  const renderSelectedComponent = () => {
    switch (selectedTab) {
      case "calendar":
        if (layoutMode === LAYOUT_APPOINTMENTS) {
          return (
            <Dashboard
              embedded
              headerRow={headerRow}
              headerActions={layoutControls}
            />
          );
        }
        return (
          <NewCalendar
            layoutMode={layoutMode}
            onLayoutModeChange={setLayoutMode}
          />
        );
      case "whiteboard":
        return <WhiteboardTab />;
      case "requests":
        return <AppointmentApprove />;
      case "approvals":
        return <AppointmentsTab />;
      case "facilities":
        return <Facilities />;
      case "dashboard":
        return (
          <div
            style={{
              height: "calc(100vh - 120px)",
              overflowY: "auto",
              overflowX: "hidden",
              padding: "0 8px",
              scrollbarWidth: "thin",
              scrollbarColor: "#888 #f1f1f1",
            }}
            className="dashboard-scroll-container"
          >
            <App />
          </div>
        );
      default:
        return (
          <NewCalendar
            layoutMode={layoutMode}
            onLayoutModeChange={setLayoutMode}
          />
        );
    }
  };

  return (
    <>
      {showHomeToolbar ? null : (
        <TopBar sx={selectedTab === "requests" ? { pb: 1 } : undefined}>
          <Container maxWidth="xl">
            <Grid container spacing={0} className="flex-center">
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container spacing={0}>
                  {headerRow}
                </Grid>
              </Grid>
            </Grid>
          </Container>
        </TopBar>
      )}

      <div
        style={
          showHomeToolbar ? undefined : { width: "100%", overflow: "hidden" }
        }
      >
        {renderSelectedComponent()}
      </div>
    </>
  );
};

export default Appointments;
